/*********************** Custom JS for Boost AI Search & Discovery  ************************/

function addMetafield(element, isGridView) {
	 // Get product data & product item
   let productData = element.getParams().props.product;
   let productId = productData.id;
   if (productData?.split_product) {
      productId = productData.variant_id;
   }
   let productItem = document.querySelector('[data-product-id="' + productId + '"]');

   const keys = ['subtitle'];
  
  const metafields = productData.metafields.filter(mf => keys.includes(mf.key));

   if (metafields.length > 0) {
      let metafieldHTML = `<div class="boost-metafield">${metafields[0].value}</div>`
      if (!productItem.querySelector('.boost-metafield')) {
         if (isGridView) { // Check if it is grid view
         productItem.querySelector(".boost-sd__product-title").insertAdjacentHTML("afterend", metafieldHTML)
         } else { // List view
          productItem.querySelector(".boost-sd__product-item-list-view-layout-info .boost-sd__product-title").insertAdjacentHTML("afterend", metafieldHTML)
         }
      }
   }
}

function addAddToCart(element, isGridView) {
    // Get product data & product item
  let productData = element.getParams().props.product;
  let productId = productData.id;
  if (productData?.split_product) {
     productId = productData.variant_id;
  }

  let productItem = $('[data-product-id="' + productId + '"]');
  var productHandle=productItem.find(".boost-sd__product-link").attr("href");
  console.log("productHandle"+productHandle)
   let addToCartdHTML = '<button type="button" class="boost-sd__button boost-sd__button--circle boost-sd__button--border boost-sd__button--height-fit-content boost-sd__button--show-on-hover boost-sd__button--no-minwidth js__add-to-cart" style="width: 37px; height: 37px; font-style: normal; font-size: 18px; font-family: &quot;Harmonia Sans&quot;; font-weight: 700; text-transform: none; color: rgb(255, 255, 255); border-color: rgb(49, 54, 82); background: rgb(49, 54, 82);" data-product-handle="'+productHandle+'" fdprocessedid="96e7uk"><span class="boost-sd__button-icon boost-sd__button-icon--is-image boost-sd__button-icon--fill-current-color" style="background-image: url(&quot;https://boost-cdn-prod.bc-solutions.net/icon/plus-white.svg&quot;);"></span></button>';
   productItem.find(".js__add-to-cart").remove();
   productItem.find(".boost-sd__product-image-column--in-top").append(addToCartdHTML)
        
     
  
}


// Start Boost 216988
// Move collection description to below product list
const customize = {
    moveHeaderDescription: (componentRegistry) => {
        componentRegistry.useComponentPlugin("HeaderDescription", {
            name: "Move Collection Description Below Product List",
            apply: () => {
                let hasUpdated = false; // Prevent rendering twice
                return {
                    afterInit(element) {
                        const descriptionElement = element.getRootElm();
                        if (descriptionElement && !hasUpdated) {
                            hasUpdated = true;
                            const productListContainerElement =
                                document.querySelector(
                                    ".boost-sd-layout.boost-sd-layout--has-filter-vertical"
                                ); // Select product list
                            if (productListContainerElement) {
                                productListContainerElement.insertAdjacentElement(
                                    "afterend",
                                    descriptionElement
                                ); // Move to below product list
                            }
                        }
                    },
                };
            },
        });
    },
     customizeProductItem: (componentRegistry) => {
      const updateProductItemGridView = {
         name: 'Add grid view',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               addMetafield(element, true);
               addAddToCart(element, true);
            }
         })
      };
      const updateProductItemListView = {
         name: 'Add list view',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               addMetafield(element);
            }
         }),
      };

       const updateATCButton = {
         name: 'hide ATC if price is 0',
         enabled: true,
         apply: () => ({
           props: (props, element) => {
             try {
               const productData = element.getParentElm().getParentElm().getParentElm().getParams().props.product
               if(productData && productData.price_min == 0) {
                 props.disabled = true
               }
              // console.log(productData, element.getParams())
             } catch (error) {
               console.warn(error)
             }
             return props
           }
         }),
      };

      // Register update product grid & list
      componentRegistry.useComponentPlugin('ProductItem', updateProductItemGridView);
      componentRegistry.useComponentPlugin('ProductItemListViewLayout', updateProductItemListView);
      componentRegistry.useComponentPlugin('CTAButton', updateATCButton);
   }
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    customize.moveHeaderDescription, customize.customizeProductItem
]);
//     window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.moveHeaderDescription, customize.sortingOption]);

// End Boost 216988